import React from 'react';
import { compose, withState } from 'recompose';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import DeleteIcon from '@material-ui/icons/Delete';
import DeleteUserDialog from '../molecules/DeleteUserDialog';

const styles = {
  leftIcon: {
    padding: '0px 5px'
  }
};

const enhance = compose(withState('openDelete', 'updateOpenDelete', false));

const button = enhance(
  ({ classes, openDelete, updateOpenDelete, id, onClickAction }) => {
    const cancelAction = () => updateOpenDelete(false);
    const deleteAction = uid => {
      updateOpenDelete(false);
      onClickAction(uid);
    };
    return (
      <div>
        <Button color="secondary" onClick={() => updateOpenDelete(true)}>
          <DeleteIcon className={classes.leftIcon} />
          削除
        </Button>
        <DeleteUserDialog
          openDelete={openDelete}
          updateOpenDelete={updateOpenDelete}
          cancelAction={cancelAction}
          deleteAction={() => deleteAction(id)}
          target=""
        />
      </div>
    );
  }
);

export default withStyles(styles)(button);
